export type CircleData = {
  size: number;
  border?: string;
  backgroundColor?: string;
};

export const circle1Data: CircleData[] = [
  { size: 950, border: '2px solid #EEF6F6' },
  { size: 885, backgroundColor: '#EEF6F6' },
  { size: 845, backgroundColor: '#d5ebeb' },
  { size: 400, backgroundColor: '#EEF6F6' },
  { size: 307, backgroundColor: '#B7DEDE' },
];
export const circle2Data: CircleData[] = [
  { size: 788, border: '3px solid #FFF4DA' },
  { size: 759, backgroundColor: '#FFE6A4' },
  { size: 534, backgroundColor: '#FFD25C' },
];
export const circle3Data: CircleData[] = [
  { size: 1165, backgroundColor: '#E7E9EF' },
  { size: 1037, backgroundColor: '#C0C4D1' },
];

export type StatItem = {
  user: {
    slug: string;
    name: string;
    avatar: {
      src: string;
      width: string;
      height: string;
      widthModal: string;
      heightModal: string;
    };
    position: string;
    companyLogo: {
      src: string;
      width: string;
      height: string;
    };
  };
  shortReview: string;
  solution: string;
  results: string[];
  review: string[];
};
export const statItems: StatItem[] = [
  {
    user: {
      slug: 'helen-keegan',
      name: 'Helen Keegan',
      avatar: {
        src: 'Helen-Keegan.png',
        width: '66px',
        height: '66px',
        widthModal: '80px',
        heightModal: '80px',
      },
      position: 'Director of HR & Strategic Engagement',
      companyLogo: {
        src: 'Helen-Keegan-company-logo.png',
        width: '107.16px',
        height: '38px',
      },
    },
    review: [
      "One Village has been a game changer for our global organization, truly improving employee morale in ways traditional EAPs couldn't. When we set out to find an employee assistance program, we quickly realized that most options were just checking a box rather than actually supporting the diverse needs of our team across the U.S., Europe, Africa, and South America. With OneVillage, we knew we had found something different-something that truly met our team where they are. In less than a month, we've already seen employees actively using these resources and even referring colleagues. As HR, having an easy, effective way to connect team members with the right coach has been invaluable. This isn't just another benefit—it's a real support system that's making a tangible difference.",
    ],
    shortReview:
      'We needed an employee assistance program that truly supported our diverse global team, not just checked a box.',
    solution:
      'With OneVillage, we found a platform that met our employees where they are, providing real support tailored to their needs across the U.S., Europe, Africa, and South America.',
    results: [
      '<strong>93%</strong> of employees reported improved morale within the first month.',
      'HR cited a <strong>50% drop</strong> in unresolved wellness requests.',
      'Employees in <strong>non-U.S. regions</strong> were <strong>2.5x</strong> more likely to engage than with prior EAPs.',
    ],
  },
  {
    user: {
      slug: 'susan-saunders',
      name: 'Susan Saunders',
      avatar: {
        src: 'Susan-Saunders.png',
        width: '66px',
        height: '66px',
        widthModal: '80px',
        heightModal: '80px',
      },
      position: 'Sr. Manager, HR Business Partner',
      companyLogo: {
        src: 'Susan-Saunders-company-logo.png',
        width: '118.56px',
        height: '38px',
      },
    },
    review: [
      "OneVillage has been a game changer for me as an HR professional as well as for our staff members. Just about every week someone is thanking me for our partnership with OneVillage. People are relieved to have quick access to support and information ranging from scheduling doctor's appointments to managing claims issues to working with a nutrition, sleep, or productivity coach. We are even able to invite our family members who can take advantage of all OneVillage's knowledge and resources! The solution that Ashley and her team have built is impactful on so many levels. It truly is a holistic approach to health!",
    ],
    shortReview:
      'Our employees struggled with accessing timely support for health and wellness, from scheduling doctor’s appointments to managing claims issues.',
    solution:
      'OneVillage provides quick access to expert medical navigation, financial planning, sleep and nutrition coaching, and more - all in one place.',
    results: [
      'Claims resolution time <strong>reduced by 60%</strong>, helping employees get reimbursements faster.',
      '<strong>92%</strong> of employees said OneVillage improved their ability to manage healthcare needs.',
      '<strong>64%</strong> extended OneVillage support to at least one family member.',
    ],
  },
  {
    user: {
      slug: 'emily-power',
      name: 'Emily Power',
      avatar: {
        src: 'Emily-Power.png',
        width: '66px',
        height: '66px',
        widthModal: '80px',
        heightModal: '80px',
      },
      position: 'Vice President, Total Rewards',
      companyLogo: {
        src: 'Emily-Power-company-logo.png',
        width: '91.2px',
        height: '38px',
      },
    },
    review: [
      "Clarest Health highly recommends OneVillage as an invaluable addition to any employee benefits package. Since implementing OneVillage, our associates have consistently benefited from its comprehensive services, particularly the expert medical and insurance navigation, which has proven instrumental in resolving denied claims and streamlining pre-authorization processes. The platform's health navigation has also been crucial in supporting associates through complex diagnoses.",
      "Beyond medical support, the diverse range of coaching services, encompassing financial planning and elder care, has significantly reduced stress and saved our employees countless hours of research. The positive impact on our associates' well-being is undeniable, and we are deeply impressed with the platform's ability to enhance the lives of our employees and their families. Ashley and the OneVillage team have truly created a remarkable and effective",
    ],
    shortReview:
      'Our associates faced difficulties navigating complex insurance claims, pre-authorizations, and financial stressors.',
    solution:
      'OneVillage offers expert medical and insurance navigation, as well as coaching services in financial planning and elder care.',
    results: [
      '<strong>75%</strong> of employees engaged with OneVillage resources within the first month.',
      '<strong>3 out of 5</strong> employees reported feeling more supported in their personal and professional lives.',
      'Employee referrals <strong>increased by 40%</strong>, showing high satisfaction with the platform.',
    ],
  },
  {
    user: {
      slug: 'katie-sue',
      name: 'Katie Sue',
      avatar: {
        src: 'Katie-Sue.png',
        width: '66px',
        height: '66px',
        widthModal: '80px',
        heightModal: '80px',
      },
      position: 'Benefits Manager',
      companyLogo: {
        src: 'Katie-Sue-company-logo.png',
        width: '94px',
        height: '38px',
      },
    },
    review: [
      'OneVillage has been a game changer with specialized coaching that tackles the root of mental health issues. They enrich our employees wellbeing, and also streamline our HR process by directing members to the exact care they need'
    ],
    shortReview:
      'We needed a solution that truly addressed the root of mental health issues and made it easier for HR to connect employees with the right care.',
    solution:
      'With OneVillage, employees get tailored support, and HR gets a smarter, simpler way to deliver it.',
    results: [
      '<strong>95%</strong> of members report learning something in their session that will improve their health and well-being.',
      '<strong>4.9 out of 5</strong> average session rating from employees.',
      'HR now has a seamless, targeted way to support employee wellness.',
    ],
  },
];
